import React from "react";
export default function SVGDial1() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <rect
          fill="#000000"
          opacity="0.3"
          x="4"
          y="4"
          width="4"
          height="4"
          rx="2"
        />
        <rect fill="#000000" x="4" y="10" width="4" height="4" rx="2" />
        <rect fill="#000000" x="10" y="4" width="4" height="4" rx="2" />
        <rect fill="#000000" x="10" y="10" width="4" height="4" rx="2" />
        <rect fill="#000000" x="16" y="4" width="4" height="4" rx="2" />
        <rect fill="#000000" x="16" y="10" width="4" height="4" rx="2" />
        <rect fill="#000000" x="4" y="16" width="4" height="4" rx="2" />
        <rect fill="#000000" x="10" y="16" width="4" height="4" rx="2" />
        <rect fill="#000000" x="16" y="16" width="4" height="4" rx="2" />
      </g>
    </svg>
  );
}
